import { Text, View } from '@react-pdf/renderer';

import { ReportVehicleExtraDetails } from 'src/common/external/bambi-api/bambiApi';
import { commonStyles } from 'src/common/pdf/common.styles';

export interface VehicleInspectionReportVehicleSectionProps {
  vehicle: ReportVehicleExtraDetails;
}
export function VehicleInspectionReportVehicleSection({
  vehicle,
}: VehicleInspectionReportVehicleSectionProps) {
  return (
    <View style={{ width: '100%' }}>
      <Text style={commonStyles.strong}>Vehicle</Text>
      <View style={[commonStyles.rowBg, { padding: 6 }]}>
        <Text>
          Internal Vehicle ID:
          <Text style={commonStyles.strong}> {vehicle.nickname}</Text>
        </Text>
      </View>
      <View
        style={[commonStyles.hstack, commonStyles.rowBgAlt, { padding: 6 }]}
      >
        <View>
          <Text>
            Vehicle Type:
            <Text style={commonStyles.strong}> {vehicle.category}</Text>
          </Text>
        </View>
      </View>

      <View style={[commonStyles.hstack, commonStyles.rowBg, { padding: 6 }]}>
        <View>
          <Text>
            Vehicle:{' '}
            <Text style={commonStyles.strong}>
              {vehicle.year} {vehicle.make} {vehicle.model}
            </Text>
          </Text>
        </View>
      </View>

      <View
        style={[commonStyles.hstack, commonStyles.rowBgAlt, { padding: 6 }]}
      >
        <View>
          <Text>
            State:{' '}
            <Text style={commonStyles.strong}>
              {vehicle.license_plate_state}
            </Text>
          </Text>
        </View>
        <View>
          <Text>
            Plate:{' '}
            <Text style={commonStyles.strong}>{vehicle.license_plate}</Text>
          </Text>
        </View>
      </View>
      <View style={[commonStyles.hstack, commonStyles.rowBg, { padding: 6 }]}>
        <View>
          <Text>
            VIN: <Text style={commonStyles.strong}>{vehicle.vin}</Text>
          </Text>
        </View>
      </View>
    </View>
  );
}
